<template>
  <div class="page">
    <!-- 背景图 -->
    <div class="banner">
      <div class="banner-module">
        <img loading="lazy" src="../assets/JoinUS/bg_joinUS.jpg" />
      </div>
      <div class="banner-wrap">
        <div class="banner-content">
          <p class="gray">加入我们</p>
          <img loading="lazy" src="../assets/JoinUS/logo_joinUS.png" />
        </div>
      </div>
    </div>

    <!-- 社会招聘 -->
    <div class="content-wrap fade-in-section">
      <div class="title">社会招聘</div>
      <div>
        <div class="job-list-message clearfix">
          <h2 class="pull-left">职业信息</h2>
          <div class="pull-right">
            共<span>{{ recruitInfo.length }}</span
            >个在招职位
          </div>
        </div>
      </div>
      <div class="job-list">
        <div class="list-header">
          <div class="list-row clearfix">
            <div class="column1">职位名称</div>
            <div class="column2">职位类别</div>
            <div class="column3">工作地点</div>
            <div class="column4">招聘人数</div>
            <div class="column5">更新时间</div>
          </div>
        </div>
        <div class="list-body">
          <div v-for="(item, index) in recruitInfo" :key="index">
            <div class="list-row">
              <div class="column1">
                {{ item.position }}
              </div>
              <div class="column2">
                {{ item.department }}
              </div>
              <div class="column3">
                {{ item.city }}
              </div>
              <div class="column4">
                {{ item.count }}
              </div>
              <div class="column5">
                {{ item.updateTime }}
                <a
                  :class="item.status ? 'up-arrow-icon' : 'down-arrow-icon'"
                  @click="toogle(index)"
                ></a>
              </div>
            </div>
            <div class="job-detail" id="detail0" v-show="item.status">
              <div class="job-duty">
                <h3>职责描述:</h3>
                <p
                  v-for="(description, number) in item.JobDescription"
                  :key="number"
                >
                  {{ number + 1 }}、{{ description }}
                </p>
              </div>
              <div class="job-demand">
                <h3>任职要求:</h3>
                <p
                  v-for="(requirements, number1) in item.JobRequirements"
                  :key="number1"
                >
                  <template v-if="!requirements.detail">
                    {{ number1 + 1 }}、{{ requirements }}
                  </template>
                  <template v-if="requirements.detail">
                    <p
                      v-for="(requireDetail, number2) in requirements.detail"
                      :key="number2"
                    >
                      ({{ number2 + 1 }})、{{ requireDetail }}
                    </p>
                  </template>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "page",
  components: {
  },
  data () {
    return {
      one:false,
      two:false,
      three:false,
      four:false,
      five:false,
      six:false,
      seven: false,
      recruitInfo:[
        {
          position: "软件开发工程师",
          department: '技术',
          status: false,
          fun: this.showOne,
          city: "深圳",
          count: "若干",
          updateTime: "2025-9-9",
          JobDescription: [
            "负责数字人相关项目的开发、优化和维护工作;",
            "参与核心模块的设计与实现，确保系统高性能、高可靠性;",
            "与算法、产品团队协作，完成技术方案落地;",
            "参与制定技术发展规划;",
            "持续优化代码质量，提升开发效率;",
          ],
          JobRequirements: [
            "985、211院校本科及以上学历，计算机、电子信息、软件工程等相关专业;",
            "精通Python，熟悉常用框架（如Django/Flask/FastAPI等）;",
            "熟悉数据结构、算法及多线程编程，具备良好的代码规范意识和工程化思维;",
            "2年以上软件开发经验，有数字人、虚拟人、AI交互等相关项目经验；",
            "熟悉自然语言处理（NLP）、语音合成、计算机视觉等技术者加分； ",
            "逻辑清晰，具备较强的学习能力和问题解决能力； ",
            "良好的团队协作和沟通能力。 ",
          ]
        },
        {
          position: "机器人开发工程师",
          department: '技术',
          status: false,
          fun: this.showTwo,
          city: "深圳",
          count: "若干",
          updateTime: "2025-9-9",
          JobDescription: [
            '负责开发机器人定位与导航算法（如SLAM"路径规划"避障算法等）。',
            "设计和优化机器人运动控制算法，确保机器人在不同环境中的高效与稳定性。",
            '实现和优化机器视觉算法，提升机器人识别"感知能力。',
            "参与机器人系统的整体架构设计与技术方案评审。",
            "与硬件团队紧密合作，确保算法与硬件的无缝结合。",
            "进行性能测试与调试，解决实际应用中的算法问题。",
            "负责研究最新的机器人学算法和技术趋势，并在实际项目中应用。",
          ],
          JobRequirements: [
          '计算机、机器人、自动化、人工智能或相关专业本科及以上学历。',
            "精通至少一种编程语言（如C++、Python、Matlab等）。",
            '熟悉机器人操作系统（ROS）及相关开发工具。',
            "扎实的数学基础，了解控制理论、计算几何、概率统计等。",
            "具备SLAM、路径规划、机器人视觉、传感器融合等领域的实践经验。",
            "具有机器人算法优化、调试和实际应用经验者优先。",
            "良好的团队合作精神与沟通能力。",
          ]
        },
        {
          position: "机械装配工",
          department: '技术',
          status: false,
          fun: this.showThree,
          city: "深圳",
          count: "若干",
          updateTime: "2025-9-9",
          JobDescription: [
            '负责机器人相关产品的机械装配、电路组装及调试工作；',
            "检查装配质量，确保产品符合技术规范和工艺要求；  ",
            '协助工程师进行产品测试、故障排查及优化改进；  ',
            "系统运维及售后技术支持。",
          ],
          JobRequirements: [
          '大专及以上学历，机械、电子、自动化等相关专业优先；  ',
            "具备机械结构知识，能熟练阅读机械设计图纸（CAD/SolidWorks等）；  ",
            '有机器人、智能硬件、自动化设备等产品经验者优先；  ',
            "动手能力强，细心严谨，具备问题排查和解决能力； ",
            "具备团队协作精神，能适应生产节奏，有责任心。",
          ]
        },
        {
          position: "结构工程师",
          department: '技术',
          status: false,
          fun: this.showFour,
          city: "深圳",
          count: "若干",
          updateTime: "2025-9-9",
          JobDescription:[
            "负责公司机器人相关产品的结构设计、零部件采购；",
            "参与新产品的需求分析，根据设计要求，完成结构设计、零部件设计及装配图设计；",
            "编写相关技术文档（制作设计方案、编写设计技术要求、加工流程等）；",
            "与客户及供应商沟通产品结构事宜。",
          ],
          JobRequirements:[
            "大专及以上学历，3年以上工作经验，机械设计及相关专业；",
            "熟悉钣金，机加，塑料等制造加工工艺、熟悉各种材料的性质以及实际应用；",
            "具有较强的理解能力、沟通能力、书面表达能力和动手实操能力；",
            "具有良好的上进心、责任心、职业素养和团队合作精神。",
            "有机器人相关行业经验优先"
          ]
        },
        {
          position: "硬件工程师",
          department: '技术',
          status: false,
          fun: this.showFive,
          city: "深圳",
          count: "若干",
          updateTime: "2025-9-9",
          JobDescription:[
            "负责设计和开发电子设备中的硬件部分，包括电路板、芯片、处理器等，工作内容有电路设计、元件布局、SI&PI分析等；",
            "根据项目需求，参与产品硬件设计的方案评估和验证；",
            "撰写硬件设计文档，包括原理图、 布局图和元器件表等；",
            "负责制作原型，进行产品测试；",
            "与其他部门的同事配合完成相关工作。"
          ],
          JobRequirements:[
            "大学本科及以上学历，电子、机电或自动化等相关专业；",
            "3年以上硬件工程师经验，有丰富的电路设计、元件布局和原型制作等经验；",
            "熟悉数字电路设计原理，熟练掌握 Altium Designer 等电路设计软件；",
            "熟悉 PCB 设计软件，如 AutoCAD、Eagle 等；",
            "具备良好的沟通能力和团队合作精神；",
            "有AGV从业经验者优先。"
          ]
        },
      ]
    }
  },
  mounted() {
    // 创建观察者实例
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target); // 只触发一次
        }
      });
    }, {
      threshold: 0.1 // 元素进入视口10%时触发
    });

    // 监听所有需要渐入的元素
    document.querySelectorAll('.fade-in-section').forEach(section => {
      observer.observe(section);
    });
  },
  methods: {
    toogle(index){
      this.recruitInfo[index].status = !this.recruitInfo[index].status
    },
    showOne(){
      this.one = !this.one
    },
    showTwo(){
      this.two = !this.two
    },
    showThree(){
      this.three = !this.three
    },
    showFour(){
      this.four = !this.four
    },
    showFive(){
      this.five = !this.five
    },
    showSix(){
      this.six = !this.six
    },
  },
}
</script>

<style scoped lang="scss">
.banner {
  width: 100%;
  position: relative;
  overflow: hidden;
  .banner-module {
    height: 500px;
    overflow: hidden;
    position: relative;
    img {
      object-fit: cover;
      min-width: 100%;
      height: 100%;
      position: relative;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      display: block;
      user-select: none;
    }
  }
  .banner-wrap {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .banner-content {
      justify-content: left;
      height: 100%;
      display: flex;
      align-items: center;
      width: 1200px;
      z-index: 9;
      .gray {
        white-space: nowrap;
        font-size: 5rem;
        font-weight: 600;
        color: #00f0fa;
        margin-bottom: 3rem;
        margin-right: 28rem;
        line-height: 5.6rem;
      }
    }
  }
}
.list-boby .list-row a:hover {
  color: #0093dc;
}
.list-boby .list-row a {
  color: #666;
}
.list-row div {
  float: left;
  overflow: hidden;
  height: 5rem;
  line-height: 5rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
  font-size: 1.8rem;
  top: 0;
  z-index: 99;
}
.column1 {
  width: 30%;
}
.column2 {
  width: 15%;
}
.column3 {
  width: 15%;
}
.column4 {
  width: 20%;
}
.column5 {
  width: 19%;
}
.content-wrap {
  background-color: #f8f9fb;
  padding-bottom: 0;
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem 0 0;
  text-align: center;
  .title {
    margin-bottom: 5rem;
    font-size: 3.2rem;
    font-weight: 600;
    color: #34363d;
    user-select: none;
  }
  div {
    display: block;
    .job-list-message {
      height: 3rem;
      font-size: 1.6rem;
      line-height: 3rem;
      color: #999;
      h2 {
        padding-left: 1rem;
        margin: 0;
        font-size: 2rem;
        font-weight: 600;
        color: #333;
      }
      .pull-left {
        float: left;
      }
      .pull-right {
        margin-right: 1rem;
        float: right;
        span {
          font-size: 2rem;
          color: #0093dc;
        }
      }
    }
  }
  .job-list {
    background-color: #fff;
    padding-bottom: 2rem;
    border-bottom: 1px solid #e5e5e5;
    border-right: 1px solid #e5e5e5;
    .list-header {
      border-bottom: 1px solid gray;
      font-size: 2rem;
      margin: 0;
      font-weight: 600;
      color: #333;
      .list-row {
        line-height: 5rem;
        height: 5rem;
        padding: 0 3%;
      }
    }
    .list-body {
      margin: 0 1%;
      font-size: 1.3rem;
      .list-row {
        border-bottom: 2px dotted #c0c0c0;
        color: #666;
        height: 5rem;
        line-height: 3rem;
        a {
          margin-top: 2rem;
          top: 0;
          position: absolute;
          right: 0;
          float: right;
          padding: 1rem 2.1rem 0 0;
          cursor: pointer;
        }
        .down-arrow-icon {
          background: url("../assets/JoinUS/banner-icon.png") -28px -146px;
        }
        .up-arrow-icon {
          background: url("../assets/JoinUS/banner-icon.png") -54px -146px;
        }
        .down-arrow-icon:hover {
          background-position: -80px -145px;
        }
        .up-arrow-icon:hover {
          background-position: -54px -145px;
        }
      }
      .job-detail {
        font-size: 2rem;
        font-weight: 400;
        color: #666;
        text-align: left;
        padding: 1.2rem 2% 2rem;
        border-bottom: 0.2rem dotted #f5f5f5;
        .job-duty {
          margin-bottom: 3.5rem;
          p {
            margin: 0.2rem 0;
          }
        }
      }
      .job-demand {
        p {
          margin: 0.2rem 0;
        }
      }
    }
  }
}
.box {
  height: 400px;
}

@media screen and (max-width: 768px) {
  .banner {
    .banner-module {
      height: 25vh;
    }
    .banner-wrap {
      .banner-content {
        width: 100vw;
        .gray {
          font-size: 2rem;
          height: 3rem;
          margin-right: 10rem;
          margin-left: 3rem;
        }
        img {
          height: 12.5vh;
        }
      }
    }
  }
  .content-wrap {
    .title {
      font-size: 2rem;
      margin-bottom: 0.5rem;
      line-height: 4rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/JoinUS.vue